function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\xF0\x9F\x92\xB3\xEF\xB8\x8F \xEC\x8B\xA0\xEC\x9A\xA9\xEC\xB9\xB4\xEB\x93\x9C",
  clipPath: "url(#clip0_725_40072)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M29.833 34.058V7.10603C29.833 5.15978 28.4525 3.58203 26.7495 3.58203L8.25026 3.58203C6.54729 3.58203 5.16676 5.15978 5.16676 7.10603V34.058C5.16676 36.0043 6.54729 37.582 8.25026 37.582H26.7495C28.4525 37.582 29.833 36.0043 29.833 34.058Z",
  fill: "#4592FB"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M18.0625 13.1532V9.86719C18.0625 9.3149 17.6707 8.86719 17.1875 8.86719H14.3123C13.829 8.86719 13.4373 9.3149 13.4373 9.86719V13.1532C13.4373 13.7055 13.829 14.1532 14.3123 14.1532H17.1875C17.6707 14.1532 18.0625 13.7055 18.0625 13.1532Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M24.9181 3.58203H20.6875V37.582H24.9181V3.58203Z",
  fill: "#185DEE"
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_725_40072"
}, /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 40,
  fill: "white",
  transform: "translate(0 0.582031)"
})));

function SvgPaymentcredit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 41,
    viewBox: "0 0 35 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentcredit);
export default __webpack_public_path__ + "static/media/paymentcredit.90d9c126.svg";
export { ForwardRef as ReactComponent };